import BaseButton from 'components/atoms/baseButton';
import { VolumeDownIcon } from 'components/atoms/icons/audioPlayer/volumeDown';
import { VolumeOffIcon } from 'components/atoms/icons/audioPlayer/volumeOff';
import { VolumeUpIcon } from 'components/atoms/icons/audioPlayer/volumeUp';
import { useTranslation } from 'react-i18next';
import { RewindIcon } from 'components/atoms/icons/audioPlayer/rewind';
import { PauseIcon } from 'components/atoms/icons/audioPlayer/pause';
import { PlayIcon } from 'components/atoms/icons/audioPlayer/play';
import { StopIcon } from 'components/atoms/icons/audioPlayer/stop';
import { ForwardIcon } from 'components/atoms/icons/audioPlayer/forward';
import BaseSlider from 'components/atoms/baseSlider';
import ChevronBottom from 'components/atoms/icons/chevron-bottom';
import ChevronTop from 'components/atoms/icons/chevron-top.svg?react';

import styles from './styles.module.scss';

import type { FC } from 'react';

interface ControlsProps {
  isLoading: boolean;
  rewind: () => void;
  togglePlayPause: () => void;
  forward: () => void;
  stop: () => void;
  isPlaying: boolean;
  volume: number;
  toggleMute: () => void;
  isMuted: boolean;
  handleVolumeChange: (value: number) => void;
  toggleShowTranscript: () => void;
  showTranscript: boolean;
}

const Controls: FC<ControlsProps> = ({
  isLoading,
  rewind,
  togglePlayPause,
  forward,
  stop,
  isPlaying,
  volume,
  toggleMute,
  isMuted,
  handleVolumeChange,
  toggleShowTranscript,
  showTranscript,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles['controls-container']}>
      <div className={styles['button-container']}>
        <BaseButton
          disabled={isLoading}
          onClick={rewind}
          label={t('controls.5s')}
          type="secondary"
          icon={<RewindIcon />}
        />
        <BaseButton
          disabled={isLoading}
          width={74}
          onClick={togglePlayPause}
          label={isPlaying ? t('controls.pause') : t('controls.play')}
          type="secondary"
          icon={isPlaying ? <PauseIcon /> : <PlayIcon />}
        />
        <BaseButton
          disabled={isLoading}
          onClick={forward}
          label={t('controls.5s')}
          type="secondary"
          rightIcon={<ForwardIcon />}
        />
        <BaseButton
          disabled={isLoading}
          onClick={stop}
          label={t('controls.stop')}
          type="red-text"
          icon={<StopIcon />}
        />
      </div>
      <div className={styles['slider-container']}>
        <button onClick={toggleMute} className={styles['mute-button']}>
          {isMuted && <VolumeOffIcon />}
          {!isMuted && (
            <>
              {volume === 0 && <VolumeOffIcon />}
              {volume > 0 && volume < 50 && <VolumeDownIcon />}
              {volume >= 50 && <VolumeUpIcon />}
            </>
          )}
        </button>
        <BaseSlider
          value={isMuted ? 0 : volume}
          onChange={handleVolumeChange}
          width={80}
          height={10}
          min={0}
          max={100}
          step={1}
        />
      </div>
      <div>
        <BaseButton
          onClick={toggleShowTranscript}
          type="secondary"
          icon={showTranscript ? <ChevronTop /> : <ChevronBottom />}
        />
      </div>
    </div>
  );
};

export default Controls;
